/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: {
    x: 15,
    y: 150,
    fontSize: 16,
    fontWeight: '500',
  },
};
export function IBAN({
  isShowSecretInfo = false,
  isLoadingPAN = false,
  cardProvider = null,
  cardNumberObscured = null,
  pan = null,
  onClick = () => {},
  panError = null,
}) {
  const { x = 15, y = 100, fontSize = 16, fontWeight = 'bold' } = MAPPING[cardProvider] || {};
  return (
    <g>
      {(!isShowSecretInfo || isLoadingPAN || panError || !pan) && (
        <text
          className="cursor-pointer"
          fill="#191919"
          fontWeight="500"
          fontSize={fontSize}
          x={x}
          y={y}
          onClick={onClick}>
          {cardNumberObscured?.match(/.{1,4}/g)?.join(' ')}
        </text>
      )}
      {isShowSecretInfo && !isLoadingPAN && (
        <text fill="#142633" fontWeight={fontWeight} fontSize={fontSize} x={x} y={y}>
          {pan?.match(/.{1,4}/g)?.join(' ')}
        </text>
      )}
    </g>
  );
}
IBAN.propTypes = {
  isShowSecretInfo: PropTypes.bool,
  isLoadingPAN: PropTypes.bool,
  cardProvider: PropTypes.string,
  cardNumberObscured: PropTypes.string,
  pan: PropTypes.string,
  onClick: PropTypes.func,
  panError: PropTypes.object,
};

export default IBAN;
